import useMutationApi from '../useMutationApi';
import { useQueryClient } from '@tanstack/react-query';
import {
  TriggerFileDiscoveryRequest,
  TriggerFileDiscoveryResponse,
  RetryJobResponse,
} from './types';

export const useTriggerFileDiscovery = () => {
  const queryClient = useQueryClient();

  return useMutationApi<
    TriggerFileDiscoveryRequest,
    TriggerFileDiscoveryResponse
  >({
    endpoint: 'rexel/discovery-jobs/trigger',
    method: 'POST',
    showSuccessToast: true,
    successMessage: 'File discovery triggered successfully',
    showErrorToast: true,
    errorMessage: 'Failed to trigger file discovery',
    options: {
      onSuccess: () => {
        // Invalidate discovery jobs to show the new triggered job
        queryClient.invalidateQueries({
          queryKey: ['rexel', 'discovery-jobs'],
        });
      },
    },
  });
};

export const useRetryProcessingJob = () => {
  const queryClient = useQueryClient();

  return useMutationApi<{ jobId: string }, RetryJobResponse>({
    endpoint: 'rexel/processing-jobs/retry',
    method: 'POST',
    showSuccessToast: true,
    successMessage: 'Job queued for retry successfully',
    showErrorToast: true,
    errorMessage: 'Failed to retry job',
    transformRequest: ({ jobId }) => ({
      jobId,
      endpoint: `rexel/processing-jobs/${jobId}/retry`,
    }),
    options: {
      onSuccess: () => {
        // Invalidate processing jobs to refresh the list
        queryClient.invalidateQueries({
          queryKey: ['rexel', 'processing-jobs'],
        });
      },
    },
  });
};
